import React from 'react';
import { computed, makeObservable } from 'mobx';
import { observer } from 'mobx-react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';
import { ITranslationContextValue } from '../Translate/models/index.js';
import Translate from '../Translate/Translate.js';
import { TranslationContext } from '../Translate/Translate.js';

import { IWeightingBarConfiguration, IWeightingBarProps, IWeightingBarState } from './models/index.js';
import WeightingBlock from './styledComponents/WeightingBlock.js';
import Wrapper from './styledComponents/Wrapper.js';
import { WEIGHTING_BAR_CATEGORY_KEY, WEIGHTING_BAR_COMPONENT_KEY } from './WeightingBar.meta.js';

export class WeightingBar extends ComponentBase<IWeightingBarProps, IWeightingBarState, IWeightingBarConfiguration> {
	categoryKey = WEIGHTING_BAR_CATEGORY_KEY;
	componentKey = WEIGHTING_BAR_COMPONENT_KEY;
	translationContext: ITranslationContextValue | undefined;

	constructor(props: IWeightingBarProps) {
		super(props);

		makeObservable(this, {
			weightingBlocks: computed,
		});
	}
	get weightingBlocks() {
		const { weightingBlocks } = this.props;
		return weightingBlocks.map((block) => {
			const { value, fontColor, backgroundColor, ariaLabel, describedById } = block;
			let ariaLabelText = ariaLabel;
			if (this.translationContext && ariaLabelText) {
				ariaLabelText = this.translationContext.translate(ariaLabelText);
			}
			return (
				<WeightingBlock
					key={`weighting_block_${value}`}
					aria-label={ariaLabelText}
					aria-describedBy={describedById}
					style={{ backgroundColor, color: fontColor }}
				>
					<Translate>{value}</Translate>
				</WeightingBlock>
			);
		});
	}
	render() {
		const { className } = this.props;
		return (
			<Wrapper className={className} aria-hidden={true}>
				<TranslationContext.Consumer>
					{(translationContext) => {
						this.translationContext = translationContext;
						return this.weightingBlocks;
					}}
				</TranslationContext.Consumer>
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(observer(WeightingBar), WEIGHTING_BAR_CATEGORY_KEY, WEIGHTING_BAR_COMPONENT_KEY);
